import React from 'react';
import type { StudyTimelineProps } from '../achievements.types';

// * [COMPONENT] Vertical study timeline with degree entries and marksheet viewer buttons
export const StudyTimeline: React.FC<StudyTimelineProps> = ({ studies, onViewMarksheet }) => {
  return (
    <div className="study-timeline-wrapper">
      <div className="study-panel-header">
        <h3 className="study-heading">
          <i className="fas fa-graduation-cap" aria-hidden="true" />
          <span>Education</span>
        </h3>
      </div>

      <div className="study-timeline-track">
        {studies.map((study, idx) => (
          <div
            key={study.id}
            className="study-timeline-item"
            style={{ animationDelay: `${idx * 0.1}s` }}
          >
            {/* * Spine connector */}
            <div className="study-dot-connector">
              <span className="study-spine-dot" />
              {idx < studies.length - 1 && <span className="study-spine-line" />}
            </div>

            {/* * Education card */}
            <div className="study-card">
              <div className="study-card-header">
                <span className="study-card-years">
                  {study.startYear} — {study.endYear}
                </span>
                <span className="study-card-grade">{study.grade}</span>
              </div>

              <h4 className="study-card-degree">{study.degree}</h4>

              <div className="study-card-institution">
                <i className="fas fa-university" aria-hidden="true" />
                <span>{study.institution}</span>
              </div>

              <p className="study-card-location">
                <i className="fas fa-map-marker-alt" aria-hidden="true" />
                {study.location}
              </p>

              <p className="study-card-desc">{study.description}</p>

              {/* * Tiny button to view degree/marksheet */}
              <button
                type="button"
                className="study-marksheet-btn"
                onClick={() => onViewMarksheet(study)}
                aria-label={`View marksheet for ${study.degree}`}
              >
                <i className="fas fa-file-alt" aria-hidden="true" />
                <span>View Marksheet</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudyTimeline;
